import React, { useEffect, useState } from 'react'
import customerServices from '../../customer/customerServices';
import companyServices from '../../company/companyServices';
import { Email, Phone } from '@mui/icons-material';
import invoiceServices from '../invoiceServices';
import SelectCustomerAddress from '../../customer/components/SelectCustomerAddress';
import { useAppData } from '../../../../../context/AppDataContext';

function InvoiceHeader({invoiceDetails, companyDetails,setCompanyDetails,customerDetails,setCustomerDetails, callBack }) {

    

    const [customerLoading,setCustomerLoadingStatus] = useState(false);
    const [companyLoading,setCompanyLoadingStatus] = useState(false);
    const {getMasterLabel} = useAppData();

    const getCustomerDetails = () =>{
        setCompanyLoadingStatus(true);
        customerServices.getById(invoiceDetails.customerId).then(res=>{
            setCustomerDetails(res.data);
        }).catch(error=>{
        }).finally(()=>{
            setCompanyLoadingStatus(false);
        })
    }
    const getComapnyDetails = () =>{
        setCustomerLoadingStatus(true);
        companyServices.getById(invoiceDetails.companyId).then(res=>{
            setCompanyDetails(res.data);
        }).catch(error=>{
        }).finally(()=>{
            setCustomerLoadingStatus(false);
        })
    }

    useEffect(()=>{
        if(invoiceDetails){
            getCustomerDetails();
            getComapnyDetails();
        }
    },[invoiceDetails])

    const updateShippingAddress = (customerAddressId) =>{
        let payload = {
            id:invoiceDetails.id,
            shippingAddressId : customerAddressId,
        }
        invoiceServices.save(payload).then(res=>{
            callBack();
        })
    }

    const updateBillingAddress = (customerAddressId) =>{
        let payload = {
            id:invoiceDetails.id,
            billingAddressId : customerAddressId,
        }
        invoiceServices.save(payload).then(res=>{
            callBack();
        })
    }

    return (
        invoiceDetails && companyDetails && customerDetails &&
        <table className='table table-sm table-bordered mb-0' style={{fontSize:12}}>
            <thead>
                <tr>
                    <th className='text-center' colSpan={2}>TAX Invoice</th>
                </tr>
                <tr>
                    <td width={"65%"} className='align-top'>
                        <div class="d-flex justify-content-between">
                            <div>
                                <img src={companyDetails.logo} style={{maxHeight:".75in", maxWidth:"1.5in"}} className='bg-dark' />
                                <div><Email style={{fontSize:14}}/> : {companyDetails.email}</div>
                                <div><Phone style={{fontSize:14}}/> : {companyDetails.phone}</div>
                                <div><span className='fw-bold'>GST:</span>{companyDetails.gst}</div>
                            </div>
                            <div className='px-2'>
                                <div>{companyDetails.companyName}</div>
                                <div>{companyDetails.address}</div>
                                <div>{companyDetails.city}, {getMasterLabel("indian-state",companyDetails.state)}, {companyDetails.zip}</div>
                                <div>State : {getMasterLabel("indian-state",companyDetails.state)}</div>
                            </div>
                        </div>
                        <div>
                            
                        </div>
                    </td>
                    <td>
                        <table className='table table-striped table-sm mb-0'>
                            <tbody>
                                <tr>
                                    <td>Invoice Number</td>
                                    <td>{invoiceDetails.invoiceNumber}</td>
                                </tr>
                                <tr>
                                    <td>Invoice Date</td>
                                    <td>{invoiceDetails.invoiceDate}</td>
                                </tr>

                                <tr>
                                    <td>Due Date</td>
                                    <td>{invoiceDetails.paymentDueDate}</td>
                                </tr>

                                {invoiceDetails.orderNumber && invoiceDetails.orderNumber !== "" && 
                                <tr>
                                    <td>Order Number</td>
                                    <td>{invoiceDetails.orderNumber}</td>
                                </tr>
                                }
                                
                                {invoiceDetails.waybillNumber && invoiceDetails.waybillNumber !== "" &&
                                <tr>
                                    <td>Waybill No</td>
                                    <td>{invoiceDetails.waybillNumber}</td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td colSpan={2}>
                        <div class="d-flex justify-content-between">

                            {invoiceDetails.billingAddressId == null ?
                                <SelectCustomerAddress customerDetails={customerDetails} callBack={updateBillingAddress} caption={"Select Billing Address"} />
                                :
                                <div style={{width:"50%"}} className="hover-container">
                                    <div className='float-end'>
                                        <SelectCustomerAddress customerDetails={customerDetails} callBack={updateBillingAddress} addressId={invoiceDetails.billingAddressId} />
                                    </div>
                                    <div className='fw-bold'>Buyer  (Bill to)</div>
                                    <div>{customerDetails.customerName},  {customerDetails.customerOrg}</div> 
                                    <div>{invoiceDetails.billingAddress.address}</div>
                                    <div>{invoiceDetails.billingAddress.city}, { getMasterLabel("indian-state",invoiceDetails.billingAddress.state) }, {invoiceDetails.billingAddress.zip}</div>
                                    {customerDetails.gst !== "" && customerDetails.gst !== null &&<div>GST # {customerDetails.gst}</div> }
                                </div>
                            }
                            {invoiceDetails.shippingAddress == null ?
                                <SelectCustomerAddress customerDetails={customerDetails} callBack={updateShippingAddress} caption={"Select Shipping Address"} />
                                :
                                <div style={{width:"50%"}} className="hover-container">
                                    <div className='float-end'>
                                        <SelectCustomerAddress customerDetails={customerDetails} callBack={updateShippingAddress} addressId={invoiceDetails.shippingAddressId}/>
                                    </div>
                                    <div className='fw-bold'>Consignee  (Ship to)</div>
                                    <div>{invoiceDetails.shippingAddress.contactPerson}</div> 
                                    <div>{invoiceDetails.shippingAddress.address}</div>
                                    <div>{invoiceDetails.shippingAddress.city}, { getMasterLabel("indian-state",invoiceDetails.shippingAddress.state) },, {invoiceDetails.shippingAddress.zip}</div>
                                </div>
                            }
                            
                        </div>
                    </td>
                    
                </tr>
            </thead>
        </table>
    )
}

export default InvoiceHeader